export const mockBusiness = {
  name: "Aadu's Kitchen",
  owner: 'Shanil Tech',
  email: 'shaniltechnologies@gmail.com',
  phone: '090825 87359',
  address: '123 Main Street, Downtown',
  city: 'Mumbai',
  state: 'Maharashtra',
  country: 'India',
  pincode: '400001',
  bio: 'Authentic home-style Indian cuisine serving fresh, flavorful dishes made with love and traditional recipes passed down through generations.',
  connected: true,
  rating: 4.2,
  reviewCount: 47,
  lastPost: 'Feb 28, 2026',
  googleMapsUrl: '#',
  googleSearchUrl: '#',
}

export const mockBusinesses = [
  {
    id: '1',
    name: "Aadu's Kitchen",
    email: 'shaniltechnologies@gmail.com',
    active: true,
  },
  {
    id: '2',
    name: 'Tech Solutions Hub',
    email: 'contact@techsolutions.com',
    active: false,
  },
]
